<div id="beyond">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Excursions and Trips</h4>
                  <div class="card-body">
                    <p class="inner-lead">We believe that learning goes beyond the classroom, and that's why we offer a variety of educational and exciting trips for our students. We aim to provide our students with unique opportunities to explore new places, learn about different cultures, and make lasting memories with their classmates.</p>
                    <p class="inner-lead">At our school, we take pride in providing a well-rounded education to our students, and educational trips are an significant part of this philosophy. Our trips are carefully designed to be both educational and fun, providing students with the opportunity to learn in a hands-on and engaging way. We believe that these experiences help to broaden students' horizons, develop their cultural awareness, and instil a love of learning.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>